import { Box, Flex, Heading, HeadingProps, Text } from '@chakra-ui/react';
import React, { ReactNode, useCallback } from 'react';
import { usePageActionSlot } from '../ui/PageActionSlot';
import { FormBreadcrumb } from '../ui/Form';

interface PageTitleProps extends HeadingProps {
  children: ReactNode;
  description?: string;
  action?: ReactNode;
  backTo?: string;
  backLabel?: string;
  currentLabel?: string;
}

export const PageTitle = ({
  children,
  description,
  action,
  backTo,
  backLabel,
  currentLabel,
  ...rest
}: PageTitleProps) => {
  const { setNode } = usePageActionSlot();
  const slotRef = useCallback((node: HTMLDivElement | null) => setNode(node), [setNode]);

  return (
    <Flex align="flex-start" justify="space-between" gap="16px" mb="24px">
      <Box display="flex" flexDirection="column" gap="4px" minW={0}>
        {backTo && backLabel && (
          <Box mb="8px">
            <FormBreadcrumb
              backTo={backTo}
              backLabel={backLabel}
              currentLabel={currentLabel ?? (typeof children === 'string' ? children : '')}
            />
          </Box>
        )}
        <Heading
          as="h1"
          fontFamily="display"
          fontSize="24px"
          lineHeight="30px"
          fontWeight={500}
          color="content.strong"
          {...rest}
        >
          {children}
        </Heading>
        {description && (
          <Text fontSize="13px" lineHeight="20px" color="content.body" maxW="68ch">
            {description}
          </Text>
        )}
      </Box>
      <Flex ref={slotRef} align="center" gap="8px" flexShrink={0}>
        {action}
      </Flex>
    </Flex>
  );
};
